import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigServiceInterface } from '../../../core/services/config/config-service.interface';
import { EventsServiceInterface } from '../../../core/services/events/events.interface';

@Component({
  selector: 'gtd-across-iframe',
  templateUrl: 'across-iframe.component.html',
})
export class AcrossIframeComponent implements AfterViewInit {
  @ViewChild('acrossIframeEl') acrossIframeEl: ElementRef;
  isAcrossIframeReady = false;
  acrossIframeUrl: any;

  constructor(
    private sanitizer: DomSanitizer,
    @Inject('ConfigServiceInterface') public configService: ConfigServiceInterface,
    @Inject('EventsServiceInterface') private eventsService: EventsServiceInterface
  ) {
    this.acrossIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.configService.acrossIframeUrl.toString());
  }

  ngAfterViewInit(): void {
    this.init();
  }

  init(): void {
    let childWindow;
    try {
      childWindow = this.acrossIframeEl.nativeElement.contentWindow;
    } catch {
      //
    }
    if (childWindow) {
      this.acrossIframeEl.nativeElement.onload = () => {
        this.isAcrossIframeReady = true;
        this.eventsService.on('jwtAuthIframeUrls:loaded').subscribe(() => {
          childWindow.postMessage(
            JSON.stringify({
              method: 'page#reload',
            }),
            '*'
          );
        });
        this.eventsService.on('authService:logout').subscribe((data: any) => {
          childWindow.postMessage(
            JSON.stringify({
              method: 'page#reload',
            }),
            '*'
          );
          data.callback();
        });
      };
    }
  }
}
